import { Skeleton } from '@/_components/ui/skeleton'
import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { usersColumns } from '@/features/_columns/users-table-column'
import { FiltersBar } from '@/features/_components/filters-bar'
import { InlineSearchbox } from '@/features/_components/inline-searchbox'
import { LoadingDataTable } from '@/features/_components/loading-data-table'
import { Container } from '@/features/_components/ui/container'
import { useCompanyContext } from '@/features/_contexts/company-context'
import { useSearch } from '@tanstack/react-router'
import { CompanyHeader } from '../_components/company-header'
import { CompanyHeaderLoading } from '../_components/company-header-loading'
import { CreateUserButton } from './_components/create-user-button'
import { UsersTable } from './_components/users-table'

const CompanyUsers = ({ session }: WithAuthComponentProps) => {
  const company = useCompanyContext()
  const searchParams = useSearch({ strict: false }) as { search?: string }
  const search = searchParams?.search

  if (!company) {
    return (
      <Container className="px-14 py-10 gap-6">
        <CompanyHeaderLoading showBack />
        <FiltersBar>
          <InlineSearchbox search="" placeholder="Busque por algum usuário" disabled />
          <Skeleton className="h-8 w-[120px] rounded-md" />
        </FiltersBar>
        <LoadingDataTable columns={usersColumns} />
      </Container>
    )
  }

  return (
    <Container className="px-14 py-10 gap-6">
      <CompanyHeader
        company={company}
        backHref="/companies"
        breadcrumbs={[{ label: 'Empresas', href: '/companies' }, { label: company.name }]}
        tabs={{ showPersons: true, showUsers: true, showSettings: true }}
      />

      <FiltersBar>
        <InlineSearchbox search={search ?? ''} placeholder="Busque por algum usuário" />
        <CreateUserButton companyId={company.id} session={session} />
      </FiltersBar>

      <UsersTable columns={usersColumns} companyId={company.id} search={search} />
    </Container>
  )
}

export default WithAuth(CompanyUsers, { allowedFor: ['staff'] })
